import React from "react";
import { Form, InputGroup } from "@themesberg/react-bootstrap";

const SelectForm = ({
  id,
  label,
  icon,
  type,
  placeholder,
  handleChange,
  data,
  ...rest
}) => {
  return (
    <Form.Group id={id} className="mb-4">
      <Form.Label>{label}</Form.Label>
      <InputGroup>
        <Form.Select
          name={id}
          onChange={handleChange}
          placeholder={placeholder}
          {...rest}
        >
          {type === "date" ? (
            <YearOptions />
          ) : (
            <>
              {data?.map((item, i) => (
                <option key={i} value={item.id}>
                  {item.nama}
                </option>
              ))}
              <option value="">Pilih opsi</option>
            </>
          )}
        </Form.Select>
      </InputGroup>
    </Form.Group>
  );
};

const YearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= 1900; year--) {
    years.push(
      <option key={year} value={year}>
        {year}
      </option>
    );
  }
  return years;
};

export default SelectForm;
